<template>
  <div class="app">
    <scroll @refresh="refresh" class="scroll-height">
      <section class="field-box">
        <dl class="field">
          <dd>{{ hospitalName }}</dd>
        </dl>
        <dl class="field">
          <dd>
            {{ param.queryParam.deptName }}/{{ param.queryParam.doctName }}
          </dd>
        </dl>
        <dl class="field">
          <dt>姓名</dt>
          <dd>{{ param.queryParam.holderName }}</dd>
        </dl>
        <dl class="field">
          <dt>卡号</dt>
          <dd>
            {{ param.queryParam.cardType | cardType }}/{{
              param.queryParam.cardNo
            }}
          </dd>
        </dl>
        <dl class="field">
          <dt>订单号</dt>
          <dd>{{ param.queryParam.visitId }}</dd>
        </dl>
        <dl class="field">
          <dt>开单时间</dt>
          <dd>{{ param.queryParam.startDate | formatpayDate }}</dd>
        </dl>
      </section>
      <div v-for="(item, index) in unpayDetailList">
        <section class="thick">
          <div class="title" @click="showDetail(item)">
            <span class="f-strong">{{ item.recipeName }}</span>
            <div
              style="display: inline-block; float: right; padding-right: 1rem"
            >
              <span class="f-strongest">{{ item.recipeFee | formatFee }}</span>
              <span v-if="item.showDetailInfo" class="arr-gray-down"></span>
              <span v-if="!item.showDetailInfo" class="arr-gray-up"></span>
            </div>
          </div>
          <div v-show="!item.showDetailInfo">
            <div v-for="subItem in item.items" class="report-detail">
              <div class="field" style="background: #f8f8f8">
                <div>
                  <label>{{ subItem.itemName }}</label>
                </div>
              </div>
              <div class="report-table-container">
                <table class="report-table">
                  <tr>
                    <td class="f-minor">单价</td>
                    <td class="f-minor">数量</td>
                    <td class="f-minor">总价</td>
                  </tr>
                  <tr>
                    <td>{{ subItem.itemFee | formatFee }}</td>
                    <td>{{ subItem.itemQty | formatItemQty }}</td>
                    <td>
                      {{ (subItem.itemFee * subItem.itemQty) | formatFee }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </scroll>
    <div v-show="canPay(param.queryParam.canPay)" class="unpay-goPay">
      <div class="unpay-money">
        <span>总金额</span>
        <span class="f-strongest">{{ param.queryParam.fee | formatFee }}</span>
      </div>
      <!--<div @click="confirm" class="goPay">-->
      <!--<span style="color: white;font-size: 16px;">立即缴费</span>-->
      <!--</div>-->
    </div>
    <payConfirm v-model="showPayConfirm"></payConfirm>
  </div>
</template>
<script>
import PayConfirm from 'PayConfirm'
export default {
  components: {
    PayConfirm
  },
  methods: {
    refresh () {
      this.messagePush();
      this.postParam = this.param.queryParam;
      var url = '/app/clinic/unpay/detail/{cardType}/{cardNo}/{visitId}';
      window.http.get(url, {
        params: this.postParam
      }).then(res => {
        if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
          var result = res.data.data;
          if (result.length > 0) {
            for (var i = 0; i < result.length; i++) {
              result[i].showDetailInfo = false;
            }
            this.unpayDetailList = result;
            this.hospitalName = this.unpayDetailList[0].hospitalName;
          }
        } else {
          this.$utils.alert(res.data.resultMsg)
        }
      });
    },
    confirm () {
      //确认缴费 生成orderId
      window.http.post('/app/clinic/unpay/confirm', {
        cardType: this.param.queryParam.cardType,
        cardNo: this.param.queryParam.cardNo,
        visitId: this.param.queryParam.visitId
      }).then(res => {
        const result = res.data;
        if (result.resultCode === this.constant.RESULT_SUCCESS) {
          this.orderId = res.data.data.orderId;
          this.fee = res.data.data.fee;
          this.goPay(this.postParam, this.orderId);
        } else {
          this.$utils.alert(res.data.resultMsg)
        }
      });
    },
    goPay () {
      //将数据存入本地
      this.$store.commit('updateParam', {
        namespace: 'pay',
        payInfo: {
          cardType: this.param.queryParam.cardType,
          cardNo: this.param.queryParam.cardNo,
          orderType: 2,
          fee: this.param.queryParam.fee,
          orderId: this.orderId,
          busiType: '2'
        }
      });
      //缴费成功后自动跳转到已缴费详单。存入数据
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        //pay: unpay,
        queryParam: {
          holderName: this.param.queryParam.holderName,
          cardType: this.param.queryParam.cardType,
          cardNo: this.param.queryParam.cardNo,
          orderTime: this.param.queryParam.startDate,
          orderId: this.orderId,
          doctName: this.param.queryParam.doctName,
          fee: this.param.queryParam.fee,
          visitName: this.param.queryParam.visitName,
        }
      });
      this.showPayConfirm = true;
    },
    showDetail (item) {
      item.showDetailInfo = !item.showDetailInfo;
    },
    canPay (canPay) {
      return canPay === 1;
    },
    messagePush () {
      var query = this.$router.currentRoute.query;
      //区分消息推送和正常页面跳转
      if (query.visitId) {
        //消息推送情况下，将需要的参数取下来保存至this.param.queryParam
        const geturlParam = {
          "canPay": parseInt(query.canPay),
          "cardNo": query.cardNo,
          "cardType": query.cardType,
          "deptName": query.deptName,
          "doctName": query.doctName,
          "fee": query.fee,
          "holderName": query.holderName,
          "startDate": query.startDate,
          "visitId": query.visitId
        };
        this.param.queryParam = geturlParam;

        //设置医院消息头和localStorage
        const hospital = {
          "hospitalId": query.hospitalId,
          "hospitalIndex": query.hospitalIndex,
          "hospitalName": query.hospitalName,
          "hospitalType": query.hospitalType
        };
        localStorage.selectedHospital = JSON.stringify(hospital);
        window.http.headers.common['hospitalId'] = hospital.hospitalId;
      } else {
        this.param.queryParam = this.$store.state.paramModule.param.myUnpay.queryParam;
      }
    }
  },
  data () {
    return {
      param: {
        queryParam: {}
      },
      unpayDetailList: [],
      orderId: '',
      fee: '',
      hospitalName: '',
      postParam: {},
      showPayConfirm: false
    }
  },
  created () {
    this.refresh()
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";

.scroll-height {
  margin-bottom: 1.8rem;
}

.unpay-goPay {
  position: absolute;
  height: 1.8rem;
  bottom: 0;
  background-color: white;
  width: 100%;
}

.unpay-money {
  float: left;
  margin-left: 0.8rem;
  line-height: 1.8rem;
  font-size: 18px;
}

.goPay {
  float: right;
  background: $main-yellow;
  width: 6.25rem;
  text-align: center;
  line-height: 2.25rem;
}
</style>



// WEBPACK FOOTER //
// ClinicUnpayDetail.vue?ce5b8010